import dynamic from 'next/dynamic';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

const DealershipBanner = dynamic(
  () => import(/* webpackChunkName: "DealershipBanner" */ '@/dealership/Banner')
);

const PromoBanner = dynamic(
  () => import(/* webpackChunkName: "PromoBanner" */ './PromoBanner')
);

function Banner() {
  const isDealership = useIsDealershipPage();

  return isDealership ? <DealershipBanner /> : <PromoBanner />;
}

export default withErrorBoundary(Banner, undefined, undefined, 'Banner');
